import styled from 'styled-components';
import { OpenInNew } from '@clds/icon';
import { typography } from '@clds/typography';
import { BetaBadge } from '../../components/BetaBadge/BetaBadge';
import { EarlyAccessBadge } from '../../components/EarlyAccessBadge/EarlyAccessBadge';

interface DescriptionPopoverContentProps {
  heading: React.ReactNode;
  isBeta?: boolean;
  isEarlyAccess?: boolean;
  openInNewWindow: boolean;
  subheading: React.ReactNode;
  href: string;
  onClick?: (event: React.MouseEvent) => void;
}

const BadgeContainer = styled.div`
  margin-left: ${(props) => props.theme.spacing.xxs};
`;

const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const Heading = styled.p`
  ${typography.xs.regular}
  align-items: center;
  display: flex;
  margin: 0 0 ${(props) => props.theme.spacing.xxs} 0;
`;

const Subheading = styled.p`
  ${typography.xxs.regular}
  margin: 0;
`;

const OpenInNewContainer = styled.div`
  margin-left: ${(props) => props.theme.spacing.xl};
`;

const Anchor = styled.a`
  align-items: center;
  display: flex;
  padding: ${(props) => props.theme.spacing.sm};

  &:hover {
    background-color: ${(props) => props.theme.palette.primary}0f;
    text-decoration: none;
  }
`;

export const DescriptionPopoverContent: React.FC<DescriptionPopoverContentProps> = ({
  heading,
  isBeta,
  isEarlyAccess,
  openInNewWindow,
  subheading,
  href,
  onClick,
}) => {
  const anchorProps = openInNewWindow ? { target: '_blank', rel: 'noopener noreferrer' } : {};
  return (
    <Anchor {...anchorProps} href={href} onClick={onClick}>
      <TextColumn>
        <Heading>
          {heading}{' '}
          {isBeta && (
            <BadgeContainer>
              <BetaBadge />
            </BadgeContainer>
          )}
          {isEarlyAccess && (
            <BadgeContainer>
              <EarlyAccessBadge />
            </BadgeContainer>
          )}
        </Heading>
        <Subheading>{subheading}</Subheading>
      </TextColumn>

      {openInNewWindow && (
        <OpenInNewContainer>
          <OpenInNew size="md" color="contrastLow" />
        </OpenInNewContainer>
      )}
    </Anchor>
  );
};
